import { CheckCircle2, Goal, UserPlus, UsersRound } from "lucide-react";
import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const metricConfig = [
  ["total_users", "Usuários cadastrados", UsersRound],
  ["new_users_today", "Cadastros hoje", UserPlus],
  ["new_users_this_month", "Cadastros no mês", UserPlus],
  ["total_goals", "Metas criadas", Goal],
  ["completed_goals", "Metas concluídas", CheckCircle2],
];

export const AdminMetrics = () => {
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/admin/summary")
      .then((response) => setSummary(response.data))
      .catch((requestError) => setError(formatApiError(requestError)));
  }, []);

  return (
    <section data-testid="admin-platform-summary" className="mb-10">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-sm font-bold uppercase tracking-wide text-amber-800">CofreWeb</p>
          <h1 className="mt-2 font-heading text-4xl font-extrabold text-emerald-950">Painel administrativo</h1>
        </div>
        <p className="text-base font-semibold text-slate-600">Visão geral da plataforma</p>
      </div>
      {error && <p data-testid="admin-summary-error" role="alert" className="mt-5 rounded-xl border-2 border-red-200 bg-red-50 p-4 text-red-800">{error}</p>}
      <div className="mt-6 grid grid-cols-2 gap-3 lg:grid-cols-5">
        {metricConfig.map(([key, label, Icon]) => (
          <div key={key} data-testid={`admin-metric-${key}`} className="rounded-2xl border border-amber-200 bg-white p-5 shadow-sm">
            <Icon className="h-6 w-6 text-amber-700" />
            <p className="mt-4 text-sm font-bold uppercase tracking-wide text-slate-600">{label}</p>
            <p className="mt-1 font-heading text-3xl font-extrabold text-emerald-950">{summary ? summary[key] : "—"}</p>
          </div>
        ))}
      </div>
    </section>
  );
};